module.exports = __webpack_public_path__ + "static/media/abs_small.04b5e8ee.png";